import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { registrationActions } from "../store/registrationSlice";

export default function Status() {
  const [searchParams] = useSearchParams();
  const outcome = searchParams.get("outcome");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(registrationActions.setActiveStep(2));
  }, []);

  return (
    <>
      <Typography variant="h5" gutterBottom>
        {outcome === "success" ? (
          <>Booking Success!</>
        ) : (
          <>Booking Unsuccessful &#x1F641;</>
        )}
      </Typography>
      <Typography variant="subtitle1">
        {outcome === "success" ? (
          <>
            We have emailed your booking confirmation. If you have any queries,
            please email{" "}
            <a href="business@Mofunland.com">business@Mofunland.com</a> See you
            at Mofunland!
          </>
        ) : (
          <>
            We are unsure why you cancelled but if you have any queries please
            email <a href="business@Mofunland.com">business@Mofunland.com</a>
          </>
        )}
      </Typography>
    </>
  );
}
